import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import { PAGE_NAMES, MISCELLANEOUS_RESOURCES, ACTION } from 'constant';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import ListMessageCenterCards from './submodules/list';
import CreateMessageCenterCards from './submodules/create';
import EditMessageCenterCards from './submodules/edit';

const MessageCenterDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.messageCenter}
				configActionName={ACTION.getAllCardsForMessageCenter}
				exact
				path={`${path}/list`}
				component={ListMessageCenterCards}
			/>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.messageCenter}
				configActionName={ACTION.createMessageCenterCard}
				exact
				path={`${path}/create`}
				component={CreateMessageCenterCards}
			/>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.messageCenter}
				configActionName={ACTION.updateMessageCenterCard}
				exact
				path={`${path}/edit`}
				component={EditMessageCenterCards}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default MessageCenterDashboard;
